// Placeholders de carga con la misma forma de las tarjetas reales, para
// evitar el salto de layout y el spinner genérico al esperar datos.
function Block({ w, h, r = 4, style }) {
  return <div className="skeleton-block" style={{ width: w, height: h, borderRadius: r, ...style }} />;
}

function CompanyCardSkeleton() {
  return (
    <div className="company-card skeleton-card" aria-hidden="true">
      <div className="company-card-top">
        <Block w={52} h={52} r={12} />
      </div>
      <div className="company-card-body">
        <Block w="70%" h={15} />
        <Block w="40%" h={11} style={{ marginTop: 4 }} />
      </div>
      <div className="company-card-footer">
        <Block w="35%" h={11} />
        <Block w="30%" h={11} />
      </div>
      <Block w="100%" h={34} r={7} />
    </div>
  );
}

function DocCardSkeleton() {
  return (
    <div className="doc-card skeleton-card" aria-hidden="true">
      <div className="doc-card-top">
        <Block w={28} h={28} r={8} />
        <Block w={38} h={16} />
      </div>
      <div className="doc-card-body">
        <Block w="85%" h={13} />
        <Block w="95%" h={10} style={{ marginTop: 6 }} />
        <Block w="55%" h={10} />
      </div>
      <div className="doc-card-actions">
        <Block w={64} h={24} r={6} />
        <Block w={64} h={24} r={6} />
        <Block w={64} h={24} r={6} />
      </div>
    </div>
  );
}

export function SkeletonGrid({ variant = "company", count = 6 }) {
  const Card = variant === "doc" ? DocCardSkeleton : CompanyCardSkeleton;
  const gridClass = variant === "doc" ? "doc-grid" : "company-grid";
  return (
    <div className={gridClass}>
      {Array.from({ length: count }).map((_, i) => <Card key={i} />)}
    </div>
  );
}
